/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedConflictOccupant
 */
export interface BedConflictOccupant {
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
}

/**
 * Check if a given object implements the BedConflictOccupant interface.
 */
export function instanceOfBedConflictOccupant(value: object): value is BedConflictOccupant {
    return true;
}

export function BedConflictOccupantFromJSON(json: any): BedConflictOccupant {
    return BedConflictOccupantFromJSONTyped(json, false);
}

export function BedConflictOccupantFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedConflictOccupant {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function BedConflictOccupantToJSON(json: any): BedConflictOccupant {
    return BedConflictOccupantToJSONTyped(json, false);
}

export function BedConflictOccupantToJSONTyped(value?: BedConflictOccupant | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id': value['lead_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

